import {Component, Input} from '@angular/core';
import {NavItem} from '../../../../models/nav-item.model';


@Component({
    selector: 'app-sidebar-item',
    templateUrl: './sidebar-item.component.html',
    styleUrls: ['./sidebar-item.component.less'],
})
export class SidebarItemComponent {
    @Input() item: NavItem;
}
